export default "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAAAAEAfQ//73vxmBiOh/AAA="